import { forwardRef } from 'react'
import styled from 'styled-components/macro'

export const Measure = forwardRef( ( { children}, ref ) => {

  return (
    <>
      <Box ref={ref}>
        { children }
      </Box>
    </>
  )
})

const Box = styled.div`
  height:100%; 
  position:relative;
  /* border:10px solid blue; */
`